
import styles from './subscription-logo.module.scss';
import logo_prem from 'shared/images/logo-investor-plus.png';

export const SubscriptionLogo = () => {
	return <span>Инвестор<img src={logo_prem} className={styles.img}></img></span>
}